<template>
  <div class="popularity-wrap">
    <!-- D: 1열 -->
    <ul class="search-result-list">
      <li
        class="search-result-item"
        v-for="(item, index) in between1to5Keywords"
        :key="item.kwdNm"
      >
        <a
          href="#"
          class="result"
          @click.prevent="() => emits('select', item.kwdNm)"
        >
          {{ (index + 1).toString().padStart(2, "0") }}. {{ item.kwdNm }}
        </a>
      </li>
    </ul>
    <!-- D: 2열 -->
    <ul class="search-result-list">
      <li
        class="search-result-item"
        v-for="(item, index) in between5to10Keywords"
        :key="item.kwdNm"
      >
        <a
          href="#"
          class="result"
          @click.prevent="() => emits('select', item.kwdNm)"
        >
          {{ (index + 6).toString().padStart(2, "0") }}. {{ item.kwdNm }}
        </a>
      </li>
    </ul>
  </div>

  <!-- D: MO 전용 -->
  <span class="search-date only-mo">
    {{ dayjs().subtract(1, "day").format("YYYY-MM-DD") }} 기준
  </span>

  <!-- D: 검색어가 없을 경우 -->
  <div v-show="keywords.length === 0" class="search-nodata">
    <p class="text">인기 검색어가 없습니다.</p>
  </div>

  <!-- D: PC 전용 -->
  <span class="search-date only-pc">
    {{ dayjs().subtract(1, "day").format("YYYY-MM-DD") }} 기준
  </span>
</template>
<script setup>
import { onMounted, ref, inject, computed, defineEmits } from "vue";
import { api } from "@/plugins/api";
import dayjs from "dayjs";

const emits = defineEmits(["select"]);

const url = inject("url_prefix");

const keywords = ref([]);

onMounted(() => {
  loadFashionKeyowrds();
});

const between1to5Keywords = computed(() => {
  return keywords.value.slice(0, 5);
});

const between5to10Keywords = computed(() => {
  return keywords.value.slice(5, 10);
});

const loadFashionKeyowrds = async () => {
  const res = await api.get(`${url}/agency/search/populateKeywords`);

  const { resultCode } = res;
  if (resultCode !== 200) {
    //alert(`errror : resultCode:${resultCode}, message:${message} `);
    return;
  }

  keywords.value = res.data;
};
</script>
